import "animate.css";
import "sal.js/dist/sal.css";
import "./style/index.css";
import "./i18n";
import App from "./components/app";

export default App;
